import axios from 'axios';
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  uploadAudience(id, formData) {
    return axios.post(`${this.url}/${id}/audience`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  getMetrics(id) {
    return axios.get(`${this.url}/${id}/metrics`);
  }
}

export default new CampaignsAPI();
